<template>
    <v-container class="bodyPage page">
        <body style="height:100%;">
            <v-row style="height:100%; margin:0;">
                <v-col xs="12" sm="12" md="4" lg="4" xl="4" class="leftMenu">
                    <v-card width="100%" height="100%" class="elevation-4">
                        <v-list-item two-line >
                            <v-list-item-content>
                                <v-list-item-title class="text-h7 headerCallInfo" style="margin-bottom:10px;font-weight:bolder; display:flex; height: 1.8em; color:#2c3e50;">
                                    {{'Pedido' | translate('Pedido') }} {{this.order.PEDIDO}}
                                    <v-spacer></v-spacer>
                                    <div class="actions">
                                        <v-btn
                                            x-small
                                            class="btn1"
                                            dark
                                            @click="goBack()"
                                        >
                                            <v-icon x-small>
                                                mdi-arrow-left
                                            </v-icon>
                                            <span style="margin-left: 4px;">{{ 'Voltar' | translate('Pedido') }}</span>
                                        </v-btn>
                                        <v-btn 
                                            v-if="this.$route.params.id"
                                            style="margin-left: 8px;"
                                            x-small 
                                            color="black"
                                            class="btn1 white--text"
                                            :disabled="!getClientCall || confirmed"
                                            @click="confirmOrder()"
                                        > 
                                            <v-icon x-small>
                                                mdi-check
                                            </v-icon>
                                            <span style="margin-left: 4px; margin-right: 4px;">{{'Confirmar' | translate('Pedido')}}</span>
                                        </v-btn>
                                        <v-btn 
                                            v-if="!this.$route.params.id"
                                            style="margin-left: 8px;"
                                            x-small 
                                            color="black"
                                            class="btn1 white--text"
                                            @click="save()"
                                            :disabled="!getClientCall"
                                        > 
                                            <v-icon x-small>
                                                mdi-content-save-all-outline
                                            </v-icon>
                                            <span style="margin-left: 4px; margin-right: 4px;">{{'Salvar' | translate('Pedido')}}</span>
                                        </v-btn>
                                         <v-btn 
                                            v-if="this.$route.params.id"
                                            style="margin-left: 8px;"
                                            x-small 
                                            color="black"
                                            class="btn1 white--text"
                                            @click="save()"
                                            :disabled="!getClientCall"
                                        > 
                                            <v-icon x-small>
                                                mdi-content-save-all-outline
                                            </v-icon>
                                            <span style="margin-left: 4px; margin-right: 4px;">{{'Salvar' | translate('Pedido')}}</span>
                                        </v-btn>
                                        <v-tooltip bottom v-if="this.$route.params.id">
                                            <template v-slot:activator="{on, attrs}">
                                                <v-btn 
                                                    x-small 
                                                    style="margin-left: 8px;"
                                                    color="black"
                                                    v-on="on"
                                                    v-bind="attrs"
                                                    class="btn1 white--text"
                                                    @click="isReadyToEmail()"
                                                    :disabled="!confirmed"
                                                > 
                                                    <v-icon x-small>
                                                        mdi-email-send
                                                    </v-icon>
                                                </v-btn>
                                            </template>                                            
                                            <span>{{ 'Enviar para planejamento' | translate('Pedido') }}</span>
                                        </v-tooltip>
                                        <v-tooltip bottom v-if="this.$route.params.id">
                                            <template v-slot:activator="{on, attrs}">
                                                <v-btn 
                                                    v-on="on"
                                                    v-bind="attrs"
                                                    x-small 
                                                    style="margin-left: 8px;"
                                                    color="black"
                                                    class="btn1 white--text"
                                                    :loading="loadingBudget"
                                                    @click="print()"
                                                > 
                                                    <v-icon x-small>
                                                        mdi-file-chart-outline
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>{{ 'Enviar orçamento' | translate('Pedido') }}</span>
                                        </v-tooltip>
                                    </div>
                                    <div class="actions">
                                        <v-tooltip bottom v-if="this.$route.params.id">
                                            <template v-slot:activator="{on, attrs}">
                                                <v-btn 
                                                    x-small 
                                                    style="margin-left: 28.9em;"
                                                    color="black"
                                                    v-on="on"
                                                    v-bind="attrs"
                                                    class="btn1 white--text"
                                                    @click="pdfDialog = true"
                                                > 
                                                    <v-icon x-small>
                                                        mdi-file-pdf-box
                                                    </v-icon>
                                                </v-btn>
                                            </template>                                            
                                            <span>{{ 'Abre tela de geração de pdf' | translate('Pedido') }}</span>
                                        </v-tooltip>
                                        <v-tooltip bottom v-if="this.$route.params.id">
                                            <template v-slot:activator="{on, attrs}">
                                                <v-btn 
                                                    x-small 
                                                    style="margin-left: 8px;"
                                                    color="black"
                                                    v-on="on"
                                                    v-bind="attrs"
                                                    class="btn1 white--text"
                                                    @click="sendAttachmentPdfEmail"
                                                    :loading="loadingSendAttachmentPdf"
                                                    :disabled="disableAttachmentPdfEmail"
                                                > 
                                                    <v-icon x-small>
                                                        mdi-send
                                                    </v-icon>
                                                </v-btn>
                                            </template>                                            
                                            <span>{{ 'Envia pdf gerado para o cliente' | translate('Pedido') }}</span>
                                        </v-tooltip>
                                    </div>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title class="text-h7 headerCallInfo" style="margin-bottom:10px; font-weight:bolder; display:flex; height: 1.8em;color:#2c3e50;">
                                    Atendimentos
                                </v-list-item-title>
                                <v-list-item-subtitle style="display:flex;">
                                    <v-menu
                                        top
                                        offset-x
                                        content-class="call-menu"
                                        class="call-menu"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-card 
                                                v-if="order.ID" 
                                                x-small 
                                                text 
                                                outlined
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                {{order.ID}}
                                            </v-card>
                                        </template>
                                        <v-list>
                                            <v-list-item>
                                                <v-card 
                                                    x-small 
                                                    text 
                                                    outlined
                                                    @click="gotoCall(callTypes.customer)"
                                                >
                                                    {{labels.cliente}}
                                                </v-card>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-card 
                                                    x-small 
                                                    text 
                                                    outlined
                                                    @click="gotoCall(callTypes.operator)"
                                                >
                                                    {{labels.operador}}
                                                </v-card>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                    
                                    <v-spacer></v-spacer>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <div class="leftMenuCardBody">
                            <v-row style="margin-top:15px;">
                                <v-col style="padding-bottom:0px; padding-top:16px" class="bolder fontSize">
                                    <template>
                                        <v-autocomplete
                                            dense
                                            height="30px"
                                            clearable
                                            v-model="order.CLIENTE"
                                            :items="clients"
                                            return-object
                                            hide-selected
                                            :menu-props="{closeOnContentClick:true}"
                                            item-text="NOME"
                                            item-value="ID"
                                            :readonly="this.readOnly"
                                        >                   
                                            <template #label>
                                                <span>{{labels.cliente}}</span> 
                                                <span class="red--text"><strong>*</strong></span>
                                            </template>              
                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                            <v-chip
                                                :key="JSON.stringify(item.ID)"
                                                v-if="item === Object(item)"
                                                v-bind="attrs"
                                                :input-value="selected.value"
                                                @click:close="parent.selectItem(item.value)"
                                                class="kndChip"
                                            >
                                                <span class="pr-2">
                                                    {{ item.NOME }}
                                                </span>
                                            </v-chip>
                                            </template>
                                            <template v-slot:[`item`]="{ item }">
                                                <v-avatar 
                                                    size="22" 
                                                    style="margin-right:5px;"  
                                                >
                                                    <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                                </v-avatar>
                                                <span class="pr-2">
                                                    {{ item.NOME }}
                                                </span>
                                            </template>
                                            <template v-if="fastSearchClients" v-slot:no-data>
                                                <span> </span>
                                            </template>
                                            <template v-slot:append-item v-if="!user.CLIENTE_ID">
                                                <v-row>
                                                    <v-col class="noPaddingCol">
                                                        <v-btn 
                                                            plain 
                                                            style="width: inherit;" 
                                                            @click="addClient()"
                                                        >
                                                            <v-icon color="#1976d2">
                                                                mdi-account-plus-outline
                                                            </v-icon>
                                                            <span style="margin-left:4px; color: #1976d2; font-weight: bolder;">{{'Cliente' | translate('Atendimento')}}</span>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </template>
                                        </v-autocomplete>
                                    </template>
                                </v-col>
                            </v-row>
                            <v-row style="margin-top:-8px;">
                                <v-col class="noPaddingCol bolder fontSize">
                                    <template>
                                        <v-text-field
                                            v-model="order.CONTATO_NOME"
                                            :readonly="this.readOnly"
                                        >
                                            <template #label>
                                                <span>{{labels.contato}}</span> 
                                                <span class="red--text"><strong>*</strong></span>
                                            </template>
                                        </v-text-field>
                                    </template>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="noPaddingCol bolder fontSize">
                                    <template>
                                        <v-autocomplete
                                            dense
                                            :clearable="!order.callResponsible"
                                            v-model="order.RESPONSAVEL"
                                            :items="responsibles"
                                            item-text="RESPONSAVEL"
                                            item.value="RESPONSAVEL"
                                            @focus="changeSearchProperty('responsibles')"
                                            @blur="setCallResponsibles()"
                                            :menu-props="{closeOnContentClick:true}"
                                            :readonly="this.readOnly"
                                        >
                                            <template #label>
                                                <span>{{labels.consultor}}</span> 
                                                <span class="red--text"><strong>*</strong></span>
                                            </template>
                                        </v-autocomplete>
                                    </template>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="noPaddingCol bolder fontSize">
                                    <v-text-field
                                        v-model="order.SITUACAO"
                                        readonly
                                        menu-props="auto"
                                        hide-details
                                        return-object
                                    >
                                        <template #label>
                                            <span>
                                                {{labels.situacao}}
                                            </span> 
                                            <span class="red--text"><strong>*</strong></span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="noPaddingCol bolder fontSize">
                                    <v-select
                                        v-model="order.COD_TIPO"
                                        :items="orderTypes"
                                        menu-props="auto"
                                        item-value="CODIGO"
                                        item-text="NOME"
                                        hide-details
                                        return-object
                                        :readonly="this.readOnly"
                                    >
                                        <template #label>
                                            <span>{{labels.tipo_pedido}}</span> 
                                            <span class="red--text"><strong>*</strong></span>
                                        </template>
                                        <!-- <template v-slot:selection="{ item }">
                                            <span>{{ item.NOME }}</span>
                                        </template>
                                        <template v-slot:[`item`]="{ item }">
                                            <span>{{ item.NOME }}</span>
                                        </template> -->
                                    </v-select>
                                </v-col>
                                <v-col class="noPaddingCol bolder fontSize">
                                    <v-select
                                        v-model="order.RECURSO_ID"
                                        :items="orderAreas"
                                        menu-props="auto"
                                        item-value="ID"
                                        item-text="DESCRICAO"
                                        hide-details
                                        return-object
                                        :readonly="this.readOnly"
                                    >
                                        <template #label>
                                                <span>{{labels.area_pedido}}</span> 
                                                <span class="red--text"><strong>*</strong></span>
                                            </template>
                                        <!-- <template v-slot:selection="{ item }">
                                            <span>{{ item.NOME }}</span>
                                        </template>
                                        <template v-slot:[`item`]="{ item }">
                                            <span>{{ item.NOME }}</span>
                                        </template> -->
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="bolder fontSize">
                                    <template>
                                        <v-autocomplete
                                            style="margin-top:25px;"
                                            dense
                                            height="35px"
                                            clearable
                                            v-model="order.PRODUTO"
                                            :items="products"
                                            item-value="ID"
                                            return-object
                                            item-text="DESCRICAO"
                                            :menu-props="{closeOnContentClick:true}"
                                            :readonly="this.readOnly"
                                            @change="updateRequestItems()"
                                        >   
                                            <template #label>
                                                <span>{{labels.busca_produtos}}</span> 
                                                <span class="red--text"><strong>*</strong></span>
                                            </template>
                                            <template v-slot:selection="{ attrs, item, parent, selected }" >
                                                <v-chip
                                                    style="margin-top:10px;"
                                                    v-if="item === Object(item)"
                                                    v-bind="attrs"
                                                    :input-value="selected.value"
                                                    @click:close="parent.selectItem(item.ID)"
                                                    class="kndChip"
                                                >
                                                    <span>
                                                        {{ item.DESCRICAO }}
                                                    </span>
                                                    <v-btn
                                                        icon
                                                        @click="parent.selectItem(item)"
                                                    >
                                                        <v-icon color="red">
                                                            mdi-close-circle
                                                        </v-icon>
                                                    </v-btn>
                                                </v-chip>
                                            </template>
                                        </v-autocomplete>
                                    </template>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="bolder fontSize">
                                    <v-autocomplete
                                        :items="this.validations"
                                        v-model="order.VALIDATION"
                                        dense
                                        item-text="VALIDATION"
                                        height="35px"
                                        :menu-props="{closeOnContentClick:true}"
                                        readonly
                                    >   
                                        <template #label>
                                                <span>{{labels.validacoes}}</span> 
                                        </template>
                                        <template v-slot:selection="{ attrs, item }" >
                                                <v-chip
                                                    style="margin-top:5px;"
                                                    v-if="item === Object(item)"
                                                    v-bind="attrs"
                                                    class="kndChip"
                                                >
                                                    <span class="pr-2" style="margin-top:5px;margin-bottom:5px;">
                                                        {{ order.VALIDATION }}
                                                    </span>
                                                </v-chip>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col style="padding:0; display:flex">
                                    <v-checkbox
                                        style="padding:0; margin:0;margin-left:15px;"
                                        v-model="this.order.ATUALIZAR_CLIENTE"
                                        label="Atualizar no cliente"
                                        :value="this.order.ATUALIZAR_CLIENTE"
                                        readonly
                                    ></v-checkbox>
                                    <v-checkbox
                                        style="padding:0; margin:0; margin-left:25px;"
                                        v-model="this.order.ATUALIZADO_CLIENTE"
                                        label="Atualizado no cliente"
                                        :value="this.order.ATUALIZADO_CLIENTE"
                                        readonly
                                    ></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-checkbox
                                    style="padding:0; margin:0;margin-left:15px;"
                                    v-model="order.SOLICITAR_ATUALIZACAO_IMEDIATA"
                                    label="Solicitada atualização imediata na base de produção"
                                    :false-value="'N'"
                                    :true-value="'S'"
                                    readonly
                                ></v-checkbox>
                            </v-row>
                            <v-row>
                                <v-checkbox
                                    style="padding:0; margin:0;margin-left:15px; margin-bottom:10px;"
                                    v-model="order.SOLICITAR_ATT_IMEDIATA_TESTE"
                                    label="Solicitada atualização imediata na base de teste"
                                    :false-value="'N'"
                                    :true-value="'S'"
                                    readonly
                                ></v-checkbox>
                            </v-row>
                        </div>
                        <!-- NÂO DELETAR, POIS VAI SER DESCOMENTADO DEPOIS -->
                        <!-- <v-card-actions class="cardActions">
                            <v-spacer></v-spacer>
                            <v-btn text outlined color="primary" class="bolder" > {{'Gerar Proposta' | translate('Pedido')}} </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn text outlined color="primary" class="bolder"> {{'Gerar Contrato' | translate('Pedido')}} </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn text outlined color="primary" class="bolder"> {{'Gerar Pedido' | translate('Pedido')}} </v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions> -->
                    </v-card>
                </v-col>
                <v-col xs="12" sm="12" md="8" lg="8" xl="8" class="orderPage">
                    <header class="panelRigthBody">
                        Pedido
                        <div id="borderBottomTabs" class="borderBottomTabs"></div>
                        <v-tabs
                            v-resize="onResize"
                            height="50px"
                            class="headerTabs"
                            color="black"
                            slider-size="4" 
                            v-model="tab"
                            show-arrows
                        >
                            <v-tab class="pedidoTab" id="solicitacoes">
                                <span>{{'Solicitações' | translate('Pedido')}}</span>
                            </v-tab>
                            <v-tab class="pedidoTab" id="faturamento">
                                <span>{{'Faturamento' | translate('Pedido')}}</span>
                            </v-tab>
                            <!-- <v-tab class="pedidoTab" id="entrega">
                                <span>{{'Entrega' | translate('Pedido')}}</span>
                            </v-tab> -->
                            <v-tab class="pedidoTab" id="autorizacao">
                                <span>{{'Autorização' | translate('Pedido')}}</span>
                            </v-tab>
                            <v-tab class="pedidoTab" id="ocorrencias">
                                <span>{{'Ocorrências' | translate('Pedido')}}</span>
                            </v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tab" style="height: 96%;">
                            <v-tab-item style="padding: 6px; height: 100%;">
                                <div id="borderBottomTabs2" class="borderBottomTabs"></div>
                                <v-tabs
                                    v-resize="onResize"
                                    height="50px"
                                    class="headerTabs"
                                    color="black"
                                    slider-size="4" 
                                    v-model="tab2"
                                    show-arrows
                                >
                                    <v-tab class="pedidoTab2" id="itens">
                                        <span>{{'Itens' | translate('Pedido')}}</span>
                                    </v-tab>
                                    <v-tab class="pedidoTab2" id="detealhe_tecnico">
                                        <span>{{'Detalhe Técnico' | translate('Pedido')}}</span>
                                    </v-tab>
                                    <v-tab class="pedidoTab2" id="anexo">
                                        <span>{{'Anexos' | translate('Pedido')}}</span>
                                    </v-tab>
                                </v-tabs>
                                <v-tabs-items v-model="tab2">
                                    <v-tab-item style="padding: 6px; height: 100%;">
                                        <div class="tabBody2">
                                            <v-card style="padding:1em;">
                                                <v-row>
                                                    <v-col class="bolder fontSize">
                                                        <v-text-field v-model.lazy="order.ASSUNTO" :readonly="this.readOnly">
                                                            <template #label>
                                                                <span>{{labels.assunto}}</span> 
                                                                <span class="red--text"><strong>*</strong></span>
                                                                
                                                            </template>
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>                                              
                                                <v-row>
                                                    <v-col class="bolder fontSize">
                                                        <v-textarea
                                                            rows="7"
                                                            name="input-7-4"
                                                            v-model="order.SERVICO_SOLICITADO"
                                                            :readonly="this.readOnly"
                                                        >
                                                            <template #label>
                                                                    <span>{{labels.itens_solicitacao}}</span> 
                                                                    <span class="red--text"><strong>*</strong></span>
                                                                </template>
                                                        </v-textarea>
                                                    </v-col>
                                                </v-row>                                              
                                            </v-card>
                                        </div>
                                    </v-tab-item>
                                    <v-tab-item style="padding: 6px; height: 100%; height: 100%;">
                                        <div class="tabBody2">
                                            <v-card style="padding:1em;">
                                                <v-row>
                                                    <v-col class="bolder fontSize">
                                                        <v-textarea
                                                            rows="2"
                                                            name="input-7-4"
                                                            :label="labels.detalhe_tecnico"
                                                            v-model="order.DETALHAMENTO_TECNICO"
                                                            :readonly="this.readOnly"
                                                        >
                                                        </v-textarea>
                                                    </v-col>
                                                </v-row>                                              
                                            </v-card>
                                        </div>
                                    </v-tab-item>
                                    <v-tab-item style="padding: 6px; height: 100%;">
                                        <div class="tabBody2">
                                            <v-card style="padding:1em;">
                                                <v-card-title>
                                                    {{'Anexos de Pedido' | translate('Pedido')}}
                                                </v-card-title>
                                                <v-card-actions>
                                                    <v-col style="padding:0;">
                                                        <v-file-input style="margin-bottom:0;" label="Adicionar um anexo" filled prepend-icon="mdi-file-upload"
                                                            v-model="newFileAttachment"
                                                        >
                                                    </v-file-input>
                                                    </v-col>
                                                    <v-col style="margin-bottom:20px;">
                                                          <v-btn icon
                                                        style="cursor:pointer;"
                                                        title="Adicionar anexo"
                                                        large
                                                        @click="addFile()"
                                                        :disabled="readOnly"
                                                    > 
                                                    <v-icon color="black">mdi-plus</v-icon>
                                                    </v-btn>
                                                    </v-col>
                                                </v-card-actions>
                                                <v-card-text>
                                                    <v-list>
                                                        <v-list-item v-for="attachment in order.attachments" :key="attachment.ID" class="attachmentListItem">
                                                            {{attachment.ARQUIVO}}
                                                            <v-icon v-if="attachment.ID" right>
                                                                mdi-file-download
                                                            </v-icon>
                                                            <!-- FUNÇÃO DE BAIXAR ARQUIVO NÃO IMPLEMENTADA -->
                                                            <!-- <v-icon v-if="attachment.ID" right @click="downloadFile(attachment)">
                                                                mdi-file-download
                                                            </v-icon> -->
                                                            <v-icon v-else right color="red" @click="removeAttachment($event, attachment)">
                                                                mdi-close-circle
                                                            </v-icon>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-card-text>
                                                <v-divider/>
                                            </v-card>
                                        </div>
                                    </v-tab-item>
                                </v-tabs-items>
                            </v-tab-item>
                            <v-tab-item style="padding: 6px; height: 100%;">
                                <div class="tabBody">
                                    <v-card style="padding:1em;">
                                        <v-card-text style="padding-top: 0;">
                                            <v-row>
                                                <v-col cols="8" style="padding:0px 16px 0px 0px;">
                                                    <v-card-title>{{labels.deficicoes}}</v-card-title>
                                                    <v-row>
                                                        <v-col class="bolder fontSize">
                                                            <v-text-field v-if='!this.manualSelection' readonly @click="openSelectClassification" v-model="order.SERVICO_CLASSIFICACAO_ID.DESCRICAO">
                                                                <template #label>
                                                                    <span>{{labels.classificacao}}</span> 
                                                                    <span class="red--text"><strong>*</strong></span>
                                                                </template>
                                                            </v-text-field>
                                                            <v-select
                                                                v-if="this.manualSelection"
                                                                v-model="order.SERVICO_CLASSIFICACAO_ID"
                                                                :items="orderClassifications"
                                                                menu-props="auto"
                                                                item-text="DESCRICAO"
                                                                hide-details
                                                                return-object
                                                                :readonly="this.readOnly"
                                                            >
                                                                <template #label>
                                                                    <span>{{labels.classificacao}}</span> 
                                                                    <span class="red--text"><strong>*</strong></span>
                                                                </template>
                                                            </v-select>
                                                        </v-col>
                                                        <v-col>
                                                            <v-checkbox large color="black" v-model="manualSelection" @change="undoClassification()" label="Habilitar escolha manual da classificação."></v-checkbox>
                                                        </v-col>
                                                        <v-col
                                                            class="btnClassificarIA"
                                                        >
                                                            <v-btn 
                                                                class="white--text btn1"
                                                                small
                                                                color="black"
                                                                :disabled="!order.PEDIDO || readOnly"
                                                                @click="requestClassificationOrder()"
                                                            >
                                                                {{'Classificar com IA'}}
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col class="bolder fontSize">
                                                            <v-autocomplete
                                                                v-model="order.CONDICAO_PGTO_ID"
                                                                :readonly="this.readOnly"
                                                                :items="orderPaymentConditions"
                                                                menu-props="auto"
                                                                :label="labels.condicao_pagamento"
                                                                item-value="ID"
                                                                item-text="CONDICAO_PAGAMENTO"
                                                                hide-details
                                                                return-object
                                                            >
                                                            </v-autocomplete>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col class="bolder fontSize">
                                                            <v-layout>
                                                                <v-row style="display:flex; flex-direction:column;">
                                                                    <span style="padding-bottom:7px;">Faturar:</span>
                                                                    <v-radio-group
                                                                        v-model="order.FATURAR"
                                                                        :readonly="this.readOnly"
                                                                        row
                                                                    >
                                                                        <v-radio
                                                                            class="green--text"
                                                                            label="Sim"
                                                                            value="S"
                                                                            @click="openBillDialog()"
                                                                        ></v-radio>
                                                                        <v-radio
                                                                            style="color:red;"
                                                                            label="Não"
                                                                            value="N"
                                                                        ></v-radio>
                                                                    </v-radio-group>
                                                                </v-row>
                                                            </v-layout>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col class="bolder fontSize">
                                                            <v-text-field type="number" v-model="order.QTD_HORAS" :readonly="this.readOnly">
                                                                <template #label>
                                                                    <span>{{labels.valor_unitario}}</span> 
                                                                    <span class="red--text"><strong>*</strong></span>
                                                                </template>
                                                            </v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <!-- <v-divider inset vertical/> -->
                                                <!-- <v-col cols="4" style="padding:0;">
                                                    <v-card-title>{{ 'Parcelas' | translate('Pedido')}}</v-card-title>
                                                </v-col>
                                                <v-divider inset vertical/>
                                                <v-col cols="4" style="padding:0;">
                                                    <v-card-title>{{ 'Demonstrativo de Faturamento' | translate('Pedido')}}</v-card-title>
                                                </v-col> -->
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </div>
                            </v-tab-item>
                            <!-- <v-tab-item style="padding: 6px; height: 100%;">
                                <div class="tabBody">
                                    <v-card>
                                        <v-card-title>
                                            {{labels.deficicoes}}
                                            <v-spacer/>
                                            <v-btn
                                                style="margin-left: 8px;"
                                                color="black"
                                                small
                                                class="btn1 white--text"
                                                @click="program()"
                                            > 
                                                <v-icon x-small>
                                                    mdi-check
                                                </v-icon>
                                                <span style="margin-left: 4px;">{{'Programar' | translate('Pedido')}}</span>
                                            </v-btn>
                                        </v-card-title>
                                        <v-divider/>
                                        <v-card-text>
                                            <v-row>
                                                <v-col>
                                                    <v-select
                                                        v-model="order.area"
                                                        :items="orderAreas"
                                                        menu-props="auto"
                                                        :label="labels.area_pedido"
                                                        item-value="CODIGO"
                                                        item-text="NOME"
                                                        hide-details
                                                        return-object
                                                    >
                                                    </v-select>
                                                </v-col>                                                 <v-col>
                                                    <v-select
                                                        v-model="order.priority"
                                                        :items="orderPriorityOptions"
                                                        menu-props="auto"
                                                        :label="labels.prioridade"
                                                        item-value="CODIGO"
                                                        item-text="NOME"
                                                        hide-details
                                                        return-object
                                                    >
                                                    </v-select>
                                                </v-col>
                                                <v-col>
                                                    <v-select
                                                        v-model="order.patch"
                                                        :items="patchs"
                                                        menu-props="auto"
                                                        :label="labels.patch"
                                                        item-value="ID"
                                                        item-text="NOME"
                                                        hide-details
                                                        return-object
                                                    >
                                                    </v-select>
                                                </v-col>
                                                <v-col>
                                                    <date-picker v-model="order.DATA_ENTREGA" :placeholder="labels.data_entrega" format="DD/MM/YYYY" valueType="format" style="width: 100%; padding: 15px 0px 0px 0px;"/>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                    <v-data-table
                                                        dense
                                                        :headers="patchHeaders"
                                                        :items="patchs"
                                                        item-key="NOME"
                                                        class="elevation-2"
                                                        :items-per-page=50
                                                        :footer-props="{
                                                            'items-per-page-text': labels.itemsPerPage,
                                                            showFirstLastpage:true,
                                                            'items-per-page-options':[10, 50, 100, -1]
                                                        }"
                                                    ></v-data-table>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </div>
                            </v-tab-item> --> 
                            <v-tab-item style="padding: 6px; height: 100%;">
                                <div class="tabBody">
                                    <v-card>
                                        <v-card-actions>
                                            <v-text-field
                                                 cols="3"
                                                 style="margin: 0px 5px ;"
                                                 label="Autorização"
                                                 v-model="newAuthorization.DESCRICAO"
                                                 :readonly="this.readOnly">
                                            </v-text-field>
                                            <v-file-input
                                                style="margin: 0px 5px;"
                                                cols="3"
                                                label="Arquivo Anexo"
                                                v-model="newAuthorization.attachment"
                                                :readonly="this.readOnly"
                                                :disabled="!newAuthorization.DESCRICAO">
                                            </v-file-input>
                                            <v-btn icon
                                                title="Enviar autorização"
                                                large
                                                :disabled="!newAuthorization.DESCRICAO || readOnly"
                                                @click="addAuthorization()"
                                            >
                                                <v-icon large color="green">
                                                    mdi-checkbox-marked-circle-outline
                                                </v-icon>
                                            </v-btn>
                                        </v-card-actions>
                                        <v-card-text>
                                            <v-data-table
                                                :headers="authorizationsHeader"
                                                :items="order.authorizations"
                                                item-key="ID"
                                                :items-per-page=50
                                                :footer-props="{
                                                    'items-per-page-text': labels.itemsPerPage,
                                                    showFirstLastpage:true,
                                                    'items-per-page-options':[10, 50, 100, -1]}"
                                            >
                                                <template v-slot:[`item.DATA_HORA`]="{ item }">
                                                    <span>
                                                        {{
                                                            moment(item.DATA_HORA).format(
                                                                'DD/MM/YYYY HH:mm'
                                                            )
                                                        }}
                                                        </span>
                                                </template>
                                                <template v-slot:[`item.attachment`]="{ item }">
                                                    <span v-if="item.ID && item.attachment" :title="item.attachment">{{
                                                        item.attachment.slice(item.attachment.lastIndexOf('\\') + 1)
                                                    }}</span>
                                                    <span v-if="!item.ID" :title="item.attachment">{{item.attachment.slice(item.attachment.lastIndexOf('\\') + 1)}}  
                                                        <v-icon  right color="red" @click="cancelNewAuthorization(item)">
                                                            mdi-close-circle
                                                        </v-icon>
                                                    </span>
                                                </template>
                                                </v-data-table>
                                            </v-card-text>
                                    </v-card>
                                </div>
                            </v-tab-item>
                            <v-tab-item style="padding: 6px; height: 100%;">
                                <div class="tabBody">
                                    <v-card style="padding:5px;">
                                        <v-card-title>
                                             <span>
                                                Ocorrências
                                            </span>
                                        </v-card-title>
                                        <v-card-text>   
                                            <v-data-table
                                                :loading="loadingOccurences"
                                                :headers="occurencesHeader"
                                                :items="occurences"
                                                item-key="ID"
                                                :items-per-page=50
                                                :footer-props="{
                                                    'items-per-page-text': labels.itemsPerPage,
                                                    showFirstLastpage:true,
                                                    'items-per-page-options':[10, 50, 100, -1]
                                                }"
                                            >
                                                    <template v-slot:[`item.DATA_HORA`]="{ item }">
                                                        <span>{{
                                                            moment(item.DATA_HORA).format(
                                                                'DD/MM/YYYY HH:mm'
                                                            )
                                                        }}</span>
                                                    </template>
                                                </v-data-table>
                                        </v-card-text>

                                    </v-card>
                                </div>
                            </v-tab-item>
                        </v-tabs-items>
                    </header>
                </v-col>
            </v-row>
        </body>
        <input style="display:none;" type="file" id="fileDialogId" @change="addFile" multiple/>
        <input style="display:none;" type="file" id="fileSolicitation" @change="addSolicitationFile"/>
        <v-dialog
            v-model="addUserDialog"
            width="400px"
        >
            <v-form ref="form">
                <v-card :loading="loading">
                    <v-card-title>
                        <span class="headline">{{ 'Cadastro de Usuário' | translate('Pedido')}} </span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="registrationDialog">
                        <v-container>
                            <v-row class="rowPadding">
                                <v-col cols="12">
                                    <v-text-field
                                        autofocus
                                        :loading="loading"
                                        v-model="editedItem.NOME"
                                        :label="labels.nome"
                                        :rules="[rules.required]"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="rowPadding">
                                <v-col cols="12">
                                    <v-text-field
                                        :loading="loading"
                                        v-model="editedItem.EMAIL"
                                        :label="labels.email"
                                        :rules="[rules.email]"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row  v-if="typeNewUser == 'requester'" style="height: 4em; margin-top:0; margin-left: .5em;">
                                <v-col cols="12" style="padding-top:4px;">
                                    <v-radio-group
                                        v-model="editedItem.type"
                                        row
                                    >
                                        <v-radio
                                            :label="labels.operador"
                                            value="P"
                                        ></v-radio>
                                        <v-radio
                                            :label="labels.cliente"
                                            value="C"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                            <v-row v-if="typeNewUser == 'requester'" >
                                <v-col style="padding-bottom:0px; padding-top:16px" class="bolder fontSize">
                                    <v-select
                                        v-model="order.CLIENTE"
                                        :readonly="this.readOnly"
                                        :items="this.clients"
                                        item-text="NOME"
                                        item-value="ID"
                                        menu-props="auto"
                                        :label="labels.cliente"
                                        hide-details
                                        return-object
                                        :disabled="editedItem.type == 'P'"
                                    >
                                        <!-- <template v-slot:selection>
                                            <v-chip
                                                :input-value="order.CLIENTE.NOME"
                                                class="kndChip"
                                            >
                                                <v-avatar 
                                                    size="22"
                                                    style="margin-right:5px;"  
                                                >
                                                    <img :src="order.client.IMAGEM_PERFIL ? baseUrl + order.client.IMAGEM_PERFIL : defaultImage">
                                                </v-avatar>
                                                <span class="pr-2">
                                                    {{ order.CLIENTE.NOME }}
                                                </span>
                                            </v-chip>
                                        </template> -->
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn
                            class="white--text btn1" 
                            small
                            color="black"
                            @click="closeDialog"
                        >
                            {{'Cancelar' | translate('Pedido')}}
                        </v-btn>
                        <v-btn 
                            class="white--text btn1" 
                            small
                            color="black"
                            @click="dialogSuccess"
                            :disabled="validateForm()"
                        >
                            {{'Confirmar' | translate('Pedido')}}
                        </v-btn>
                        <v-btn 
                            class="white--text btn1" 
                            small
                            color="black"
                            @click="dialogSuccess"
                        >
                            {{'Salvar' | translate('Pedido')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <v-dialog
            v-model="callsLinkDialog" 
            class="mx-auto"
            max-width="400"   
        >
            <v-card>
                <v-card-title>{{'Vincula Atendimento' | translate('Pedido')}}</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="bodyCallLink">
                    <v-autocomplete
                        v-model="linksToApply"
                        :items="callsToLink"
                        return-object
                        :label="labels.buscar"
                        item-text="ASSUNTO"
                        item-valie="ID"
                        multiple
                    >
                        <template v-slot:no-data>
                            {{labels.no_data}}
                        </template>
                        <template v-slot:selection="{ attr, on, item, selected }">
                            <v-chip
                                v-bind="attr"
                                :input-value="selected"
                                color="#888888"
                                class="white--text"
                                v-on="on"
                            >
                                <span v-text="item.ID"></span>
                                <span class="text-truncate assuntoColumn" style="margin-left:6px;" v-text="item.ASSUNTO"></span>
                            </v-chip>
                        </template>
                        <template v-slot:item="{ item }">
                            <div style="display: flex; align-items: center;">
                                <v-chip
                                    color="#888888"
                                    size="20"
                                    class="white--text"
                                >
                                    <span v-text="item.ID"></span>
                                </v-chip>
                                <span class="text-truncate assuntoColumn" style="margin-left:6px;" v-text="item.ASSUNTO"></span>
                            </div>
                        </template>
                    </v-autocomplete>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="white--text btn1" 
                        small
                        color="black"
                        @click="cancelChangeLinks()"
                    >
                        <v-icon x-small>
                            mdi-close
                        </v-icon>
                        {{'Calcelar' | translate('Pedido')}}
                    </v-btn>
                    <v-btn
                        class="white--text btn1" 
                        small
                        color="black"
                        @click="applyChangeLinks()"
                    >
                        <v-icon x-small>
                            mdi-check
                        </v-icon>
                        {{'Ok' | translate('Pedido')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="ordersLinkDialog" 
            class="mx-auto"
            max-width="400"   
        >
            <v-card>
                <v-card-title>{{'Vincula Pedido' | translate('Pedido')}}</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="bodyCallLink">
                    <v-autocomplete
                        v-model="orderLinksToApply"
                        :items="orders"
                        return-object
                        :label="labels.buscar"
                        item-text="ASSUNTO"
                        item-valie="ID"
                        multiple
                    >
                        <template v-slot:no-data>
                            {{labels.no_data}}
                        </template>
                        <template v-slot:selection="{ attr, on, item, selected }">
                            <v-chip
                                v-bind="attr"
                                :input-value="selected"
                                color="#888888"
                                class="white--text"
                                v-on="on"
                            >
                                <span v-text="item.ID"></span>
                                <span class="text-truncate assuntoColumn" style="margin-left:6px;" v-text="item.ASSUNTO"></span>
                            </v-chip>
                        </template>
                        <template v-slot:item="{ item }">
                            <div style="display: flex; align-items: center;">
                                <v-chip
                                    color="#888888"
                                    size="20"
                                    class="white--text"
                                >
                                    <span v-text="item.ID"></span>
                                </v-chip>
                                <span class="text-truncate assuntoColumn" style="margin-left:6px;" v-text="item.ASSUNTO"></span>
                            </div>
                        </template>
                    </v-autocomplete>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="white--text btn1" 
                        small
                        color="black"
                        @click="cancelChangeOrderLinks()"
                    >
                        <v-icon x-small>
                            mdi-close
                        </v-icon>
                        {{'Calcelar' | translate('Pedido')}}
                    </v-btn>
                    <v-btn
                        class="white--text btn1" 
                        small
                        color="black"
                        @click="applyChangeOrderLinks()"
                    >
                        <v-icon x-small>
                            mdi-check
                        </v-icon>
                        {{'Ok' | translate('Pedido')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog 
            v-model="requestUpdateModal" 
            class="mx-auto"
            max-width="400"
            width="400px"
        >
            <v-card>
                <v-card-title style="display:grid; place-items:center;">
                    <v-icon>mdi-alert</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col>
                                <h2 style="font-size: 1.5em;">Deseja solicitar atualização imediata?</h2>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6">
                                <v-checkbox 
                                    large 
                                    color="black" 
                                    v-model="updateProductionBase" 
                                    label="Atualizar base de produção."
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="6">
                                <v-checkbox 
                                    large 
                                    color="black" 
                                    v-model="updateTestBase" 
                                    label="Atualizar base de teste."
                                ></v-checkbox>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions style="display:flex;justify-content:flex-end;">
                    <v-btn 
                        class="white--text btn1" 
                        small
                        color="black"
                        @click="addNewOrder()">
                        Não
                    </v-btn>
                     <v-btn   
                        class="white--text btn1" 
                        small
                        color="black" @click="requestUpdateAndConfirm()"
                        :disabled="!this.updateTestBase && !this.updateProductionBase"
                    >
                        Sim
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <template>
            <v-row justify="center">
                <v-dialog
                    v-model="errorDialog"
                    max-width="400"
                    style="padding:25px;"
                >
                <v-card style="padding-top:25px;">
                    <v-card-title>
                        <v-icon large color="red" style="margin:auto;">mdi-alert</v-icon>
                    </v-card-title>
                    <v-card-text style="color:black; font-size:18px;">
                        Pedido de classificação "Especificação" ou "Abonado" deve possuir autorização.
                    </v-card-text>

                    <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        color="red darken-1"
                        text
                        @click="errorDialog = false"
                    >
                        Ok
                    </v-btn>
                    </v-card-actions>
                </v-card>
                </v-dialog>
            </v-row>
        </template>
        <dialog-priority v-if="dialogJustifyPriority" @input="justifyPriorityHandler" @close="dialogJustifyPriority = false" :deadlineOnly="this.deadlineOnly"/>
        <dialog-classification v-if="dialogJustifyClassification" @input="justifyClassificationHandler" @close="dialogJustifyClassification = false"/>
        <bill-dialog :dialog="billDialog" @input="onSuccessBillDialog" @close="closeBillDialog"/>
        <classification-modal v-if="classificationModal"  :serviceId="defaultOrder.SERVICO_ID" :classification="defaultOrder.CLASSIFICACAO_DESCRICAO" :dialog="classificationModal" @close="closeClassificationDialog()" @save="saveClassification"></classification-modal>
        <classification-ia-modal v-if="classificationIAModal" :order="order.PEDIDO" :serviceId="order.SERVICO_ID" :dialog="classificationIAModal" @close="classificationIAModal = false" @save="saveIAClassification"></classification-ia-modal>
        <v-dialog
                v-model="controlProductivityDialog"
                width="500"
            >
                <v-card>
                    <v-card-title class="text-h5">
                    </v-card-title>
                    <v-card-text class="text-h6 black--text">
                        Deseja parar de trabalhar no atendimento {{this.lastCallIdAccessed}} e começar a trabalhar nesse?
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red"
                        text
                        @click="closeControlProductivityModal()"
                    >
                        Não
                    </v-btn>
                    <v-btn
                        color="green"
                        text
                        @click="stopPreviousAndStartWorkingInThisCall()"
                    >
                        Sim
                    </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="sendBudgetDialog"
                width="500"
            >
                <v-card>
                    <v-card-title class="text-h5">
                    </v-card-title>
                    <v-card-text class="text-h6 black--text">
                        {{'Tem certeza que deseja enviar o ' | translate('Pedido')}} <a style="font-size: inherit; text-decoration: underline;" @click="openFile()">{{'orçamento' | translate('Pedido')}}</a>?
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red"
                        text
                        @click="sendBudgetDialog = false"
                    >
                        Não
                    </v-btn>
                    <v-btn
                        color="green"
                        text
                        @click="sendPrint()"
                        :loading="loadingSendPrint"
                    >
                        Sim
                    </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="inactivityDialog"
                width="500"
                persistent
            >
                <v-card>
                    <v-card-title class="text-h5">
                    </v-card-title>
                    <v-card-text class="text-h6 black--text">
                        Atendimento pausado | Você ainda está trabalhando nesse atendimento?
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="green"
                        text
                        @click="startWorkingInThisCall(); closeInactiveModal();"
                    >
                        Sim
                    </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="pdfDialog"
                fullscreen
                ref="pdfDialog"
                hide-overlay
                transition="dialog-bottom-transition"
                style="z-index: 1002;"
                persistent
            >
                <v-card
                    class="rounded-0"
                    style="height: 100%;"
                >
                    <v-toolbar
                        dark
                        color="grey darken-4"
                        style="height: 9%; align-content: center;"
                    >
                        <v-btn
                            icon
                            dark
                            @click="pdfDialog = false"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>{{ 'Geração de pdf' | translate('Pedido') }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn
                                dark
                                text
                                @click="saveAttachmentPdf()"
                                :loading="loadingAttachmentPdf"
                            >
                                {{ 'Salvar' | translate('Pedido') }}
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <div
                        style="height: 91%; overflow-y: auto;"
                    >
                        <v-container>
                            <v-form
                                ref="generatePdfForm"
                                lazy-validation
                            >
                                <v-row>
                                    <v-col>
                                        <div style="display: flex;">
                                            <v-card class="pa-3 d-flex align-center" @click="openAttachmentPdf" style="cursor: pointer; width: 30em; margin-right: 1em;">
                                                <v-icon color="red" class="mr-2">mdi-file-pdf</v-icon>
                                                <span>{{ attachmentPdfName }}</span>
                                            </v-card>
                                            <v-btn
                                                text
                                                @click="generateAttachmentPdf"
                                                :loading="loadingGenerateAttachmentPdf"
                                                style="align-self: center; background-color: #212121; color: #fff !important;"
                                            >
                                                {{ 'Gerar anexo' | translate('Pedido') }}
                                            </v-btn>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-text-field
                                            :label="'Rotina' | translate('Pedido')"
                                            required
                                            :rules="formRules"
                                            v-model="order.ROTINA"
                                            class="default-size-text-field"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-text-field
                                            :label="'Base' | translate('Pedido')"
                                            required
                                            :rules="formRules"
                                            v-model="order.BASE"
                                            class="default-size-text-field"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col>
                                        <v-text-field
                                            :label="'Acesso' | translate('Pedido')"
                                            required
                                            :rules="formRules"
                                            v-model="order.ACESSO"
                                            class="default-size-text-field"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-text-field
                                            :label="'Login' | translate('Pedido')"
                                            required
                                            :rules="formRules"
                                            v-model="order.LOGIN"
                                            class="default-size-text-field"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col>
                                        <v-text-field
                                            :label="'Senha' | translate('Pedido')"
                                            required
                                            :rules="formRules"
                                            v-model="order.SENHA"
                                            class="default-size-text-field"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-textarea
                                            outlined
                                            required
                                            :rules="formRules"
                                            name="input-7-4"
                                            :label="'Objetivo' | translate('Pedido')"
                                            v-model="order.OBJETIVO"
                                            class="default-size-text-field"
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <div style="width: 100%; text-align: left;">
                                            <v-label class="attachment-pdf-label">{{'Solicitação' | translate('Pedido')}}</v-label>
                                        </div>
                                        <v-input
                                            :rules="formRules" v-model="order.SOLICITACAO"
                                            style="width: 100%;"
                                        >
                                            <template v-slot:default>
                                                <vue-editor
                                                    v-once
                                                    id="pdfGeneratorEditorRequest"
                                                    ref="pdfGeneratorEditorRequest"
                                                    class="editor"
                                                    :editorToolbar="customToolbar"
                                                    style="caret-color: black; width: 100%;"
                                                    auto-grow
                                                    :placeholder="'Digite aqui...' | translate('Pedido')"
                                                    v-model="order.SOLICITACAO"
                                                ></vue-editor>
                                            </template>
                                        </v-input>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <div style="width: 100%; text-align: left;">
                                            <v-label class="attachment-pdf-label">{{'Detalhamento' | translate('Pedido')}}</v-label>
                                        </div>
                                        <v-input
                                            :rules="formRules" v-model="order.DETALHAMENTO"
                                            style="width: 100%;"
                                        >
                                            <template v-slot:default>
                                                <vue-editor
                                                    v-once
                                                    id="pdfGeneratorEditorDetail"
                                                    ref="pdfGeneratorEditorDetail"
                                                    class="editor"
                                                    :editorToolbar="customToolbar"
                                                    style="caret-color: black; width: 100%;"
                                                    auto-grow
                                                    :placeholder="'Digite aqui...' | translate('Pedido')"
                                                    v-model="order.DETALHAMENTO"
                                                ></vue-editor>
                                            </template>
                                        </v-input>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-container>
                    </div>
                </v-card>
            </v-dialog>
    </v-container>
</template>
<script>

import { createNamespacedHelpers } from 'vuex'
import translate from '../../../src/plugins/translate'
import { VueEditor } from 'vue2-editor'
// import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import getClientsByCompanyIdAndName from '../../../src/app/cliente/getClientsByCompanyIdAndName'
import getNewOrderClient from '../../../src/app/cliente/getNewOrderClient'
// import getProductsByCompanyIdAndName from '../../../src/app/produto/getProductsByCompanyIdAndName'
import getProductsByCompanyIdAndName from '../../../src/app/produto/getProductModulesByCompanyIdAndName'
import loadAllResponsible from '../../../src/app/responsavelPedido/loadAllResponsible'
import loadAllRequesters from '../../../src/app/solicitanteAtendimento/loadAllRequesters'
import insertOrder from '../../../src/app/pedido/insertOrder'
import updateOrder from '../../../src/app/pedido/updateOrder'
import addNewMessage from '../../../src/app/mensagemAtendimento/addMessage'
import loadAllMessagesByCallId from '../../../src/app/mensagemAtendimento/loadAllByCallId'
import updateViewsByCallId from '../../../src/app/mensagemAtendimento/statusMensagemAtendimento/updateViewsByCallId'
import getFile from '../../../src/app/downloadArquivo/getFile'
// import reportOrder from '../../../src/reports/reportOrder'
import moment from 'moment'
import getAllOrders from '../../../src/app/pedido/getAllOrders'
import updateCallSituation from '../../../src/app/atendimento/updateCallSituation'
import updateDeadline from '../../../src/app/pedido/updateDeadline'
import getOrderClassifications from '../../../src/app/classificacaoPedido/getOrderClassifications'
import getOrderSituations from '../../../src/app/situacaoPedido/getAllOrderSituations'
import getOrderTypes from '../../../src/app/tipoPedido/getOrderTypes'
import getOrderAreasList from '../../../src/app/areaPedido/getOrderAreas'
import getAllpaymentConditions from '../../../src/app/condicaoPagamento/getAllpaymentConditions'
import loadAllAuthorizationsByOrderId from '../../../src/app/autorizacaoPedido/loadAllAuthorizationsByOrderId'
import updateAuth from '../../../src/app/autorizacaoPedido/updateAuth'
import insertAuth from '../../../src/app/autorizacaoPedido/insertAuth'
import deleteSolicitationAttachment from '../../../src/app/autorizacaoPedido/deleteSolicitationAttachment'
import getAllCallsByCompanyIdAndUserId from '../../../src/app/atendimento/getAllCallsByCompanyIdAndUserId'
import loadAllOccurences from '../../../src/app/ocorrencias/loadAllOccurences'
import getRequestItems from '../../../src/app/pedido/getRequestItems'
// import getProductById from '../../../src/app/produto/getProductById'
import getResponsibleByEmail  from '../../../src/app/consultores/getResponsibleByEmail'
import getDefaultPaymentCondition from '../../../src/app/condicaoPagamento/defaultCondition'
import sendMailPlanning from '../../../src/app/pedido/sendMailPlanning'
import JustifyPriorityDialog from './JustifyPriorityDialog.vue'
import JustifyClassificationDialog from './getClassificationMotiveDialog.vue'
import BillDialog from './BillDialog.vue'
import addAttachment from '../../../src/app/pedido/addAttachmentFile'
import sendEmailReport from '../../../src/app/pedido/sendEmailReport'
import uploadEmailReport from '../../../src/app/pedido/uploadEmailReport'
import classificationModalVue from './classificationModal.vue'
import classificationIAModalVue from './classificationIAModal.vue'
import getLastUserAccesInCall from '../../../src/app/controleProdutividade/getLastUserAccesInCall'
import insertUserAccessInCall from '../../../src/app/controleProdutividade/insertUserAccessInCall'
import { connectSocket, disconnectSocket } from '../../../src/plugins/socketIoControlProductivity'
import updateAttachmentPdf from '../../../src/app/pedido/updateAttachmentPdf'
import insertAttachmentPdf from '../../../src/app/pedido/insertAttachmentPdf'
import generateAttachmentPdf from '../../../src/app/pedido/generateAttachmentPdf'
import sendAttachmentPdf from '../../../src/app/pedido/sendAttachmentPdf'


const user = createNamespacedHelpers('user')

export default {
    name: 'Atendimento',
    components: {
        'dialog-priority' : JustifyPriorityDialog,
        'dialog-classification' : JustifyClassificationDialog,
        'bill-dialog': BillDialog,
        'classification-modal' : classificationModalVue,
        'classification-ia-modal' : classificationIAModalVue,
        VueEditor
    },
    props : ['newOrder'],
    data() {
        return {
            call : {},
            manualSelection : false,
            tab: null,
            teste : '',
            requestUpdateModal : false,
            tab2: null,
            dialogJustifyPriority : false,
            dialogJustifyClassification : false,
            classificationModal : false,
            classificationIAModal : false,
            newComment: '',
            newOrderMode : false,
            expand: false,
            defaultOrder:{},
            errorDialog:false,
            orders: [],
            enableSave:false,
            order:{
                authorizations : [],
                relatedCalls : [],
                CLIENTE : {},
                CONTATO_NOME: null,
                RESPONSAVEL: null,
                SITUACAO: null,
                COD_TIPO: null,
                ASSUNTO: null,
                SERVICO_SOLICITADO: null,
                SERVICO_CLASSIFICACAO_ID: {ID:null, DESCRICAO: ''},
                QTD_HORAS: null,
                RECURSO_ID: null,
                PRODUTO: null,
                attachments : [],
                SOLICITAR_ATUALIZACAO_IMEDIATA: false
            },
            filters: {
                default:{
                    description:'',
                    selected:[],
                    rows:[]
                }
            },
            patchHeaders: [
                { text: translate('Patch N°.', 'Pedido'), value: 'NOME', width: '30%', align:'center' },
                { text: translate('Capacidade', 'Pedido'), value: 'CARGA_HORARIA', width: '30%', align:'center' },
                { text: translate('Horas Disponíveis', 'pedido'), value: 'SALDO', width: '30%', align:'center' }
            ],
            requestersTableHeaders: [
                { text: translate('Solicitação de Autorização', 'Pedido'), value: 'SOLICITACAO', width: '40%', align:'center' },
                { text: translate('Autorizar', 'Pedido'), value: 'AUTORIZADO', width: '15%', align:'center' },
                { text: translate('Negar', 'pedido'), value: 'NEGADO', width: '15%', align:'center' },
                { text: translate('Observação', 'pedido'), value: 'OBSERVACAO', width: '20%', align:'center' },
                { text: translate('Anexo', 'pedido'), value: 'ANEXO', width: '10%', align:'center' }
            ],
            loading: false,
            search: null,
            imageTime: new Date().getTime(),
            defaultImage: require('../../../src/assets/user.png'),
            logoClient: require('../../../src/assets/empresas/logoPGD.png'),
            baseUrl: process.env.VUE_APP_API_URL,
            labels: {
                cliente: translate('Cliente', 'Pedido'),
                contato: translate('Contato', 'Pedido'),
                commentPlaceholder: translate('Digite aqui...', 'Pedido'),
                consultor: translate('Consultor','Pedido'),
                // data_inicio: translate('Data Inicio','Pedido'),
                // data_final: translate('Data Final','Pedido'),
                // acao_com: translate('Ação Com','Pedido'),
                situacao: translate('Situação','Pedido'),
                titulo_negocio: translate('Título do Negócio','Pedido'),
                busca_produtos: translate('Produto','Pedido'),
                tableProductTextNoData: translate('Nenhum produto selecionado...', 'Pedido'),
                titlePage:  translate('Pedido', 'Pedido'),
                // valor_mensal: translate('Valor Mensal do Negócio', 'Pedido'),
                // valor_negocio: translate('Valor do Negócio', 'Pedido'),
                selectResponsibleTextNoData: translate('Nenhum responsável selecionado...', 'Pedido'),
                assunto: translate('Assunto', 'Pedido'),
                operador: translate('Operador', 'Pedido'),
                nome: translate('Nome', 'Pedido'),
                email: translate('Email', 'Pedido'),
                buscar: translate('Buscar', 'Pedido'),
                no_data: translate('Nenhum Valor Encontrado', 'Pedido'),
                pedido: translate('Pedido', 'Pedido'),
                tipo_pedido: translate('Tipo Pedido', 'Pedido'),
                area_pedido: translate('Área Pedido', 'Pedido'),
                itens_solicitacao: translate('Itens da Solicitação', 'Pedido'),
                detalhe_tecnico: translate('Detalhe Técnico', 'Pedido'),
                classificacao: translate('Classificação', 'Pedido'),
                condicao_pagamento: translate('Condição de Pagamento', 'Pedido'),
                faturar: translate('Faturar', 'Pedido'),
                valor_unitario: translate('Quantidade Horas', 'Pedido'),
                prioridade: translate('Prioridade', 'Pedido'),
                patch: translate('Patch', 'Pedido'),
                data_entrega: translate('Data Entrega', 'Pedido'),
                definicoes: translate('Definições', 'Pedido'),
                solicitar_autorizacao: translate('Solicitar Autorização', 'Pedido'),
                requestersTableNoData: translate('Nenhum item encontrado', 'Pedido'),
                validacoes: translate('Validação', 'Pedido')
            },
            validations : [
                {VALIDATION : 'Colocado no Patch'},
                {VALIDATION : 'Validado Consultoria'},
                {VALIDATION : 'Validado Analista'},
                {VALIDATION : 'Validado Desenvolvimento'},
                {VALIDATION : 'Não Validado'},
            ],
            placeholders: {
                solicitation: translate('Digite aqui o que quer autorizar...', 'pedido')
            },
            rules: {
                required: (val) => !!val || translate('Deve ser preenchido!','Pedido'),
                email: (val) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(val) || translate('Email Invalido!', 'Pedido')
                }
            },
            customToolbar: [
                ["bold", "italic", "underline", "strike"],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ color: [] }, { background: [] }]
            ],
            authorizationsHeader:[
                { text: translate('Usuário', 'pedido'), value: 'USUARIO', width: '15%'},
                { text: translate('Data', 'pedido'), value: 'DATA_HORA', width: '10%' },
                { text: translate('Autorização', 'pedido'), value: 'DESCRICAO', width: '40%', align:'center' },
                { text: translate('Anexo', 'pedido'), value: 'attachment', width: '10%', align:'center' }
            ],
            newAuthorization : {
                DESCRICAO : '',
                attachment : {}
            },
            occurences : [],
            occurencesHeader : [
                { text: translate('Ocorrência', 'pedido'), value: 'TEXTO', width: '40%', align:'center' },
                { text: translate('Usuário', 'pedido'), value: 'USUARIO', width: '10%'},
                { text: translate('Data/Hora', 'pedido'), value: 'DATA_HORA', width: '10%', align:'center' }
            ],
            fastSearchProducts: null,
            fastSearchClients: null,
            fastSearchResponsibles: null,
            fastSearchRequesters: null,
            searchProperty: null,
            searchProperties: {},
            loadingFilterValues: false,
            loadingAuthorization: false,
            productTableHeaders:[
                { text: translate('Produto', 'Atendimento'), value: 'NOME', width: '40%', align:'center'},
                { text: translate('Qtd.', 'Atendimento'), value: 'QUANTIDADE', width: '10%' },
                { text: translate('Mensal', 'Atendimento'), value: 'MENSAL', width: '15%' },
                { text: translate('Horas', 'Atendimento'), value: 'HORAS', width: '15%', align:'center' },
                { text: translate('Valor', 'Atendimento'), value: 'VALOR', width: '20%', align:'center'}
            ],
            situations:[],
            products:[],
            clients:[],
            responsibles:[],
            newFileAttachment:'',
            requesters:[],
            callsToLink:[],
            orderResponsibles:[],
            orderRequesters:[],
            requestsmethods: {
                clients: getClientsByCompanyIdAndName,
                products: getProductsByCompanyIdAndName,
                responsibles: loadAllResponsible,
                requesters: loadAllRequesters
            },
            messages:[],
            loadingOccurences:false,
            editedItem: {type:'P'},
            addUserDialog: false,
            dialogSuccess: null,
            typeNewUser: null,
            callsLinkDialog: false,
            linksToApply: [],
            orderAreas: [],
            orderTypes: [],
            orderClassifications: [],
            orderSituations: [],
            orderPaymentConditions: [],
            patchs: [],
            orderInvoiceOptions: [
                {CODIGO: null, NOME: ''},
                {CODIGO: 'S', NOME: translate('Sim', 'Pedido')},
                {CODIGO: 'N', NOME: translate('Não', 'Pedido')},
            ],
            orderPriorityOptions: [
                {CODIGO: 'N', NOME: translate('Normal', 'Pedido')},
                {CODIGO: 'P', NOME: translate('Paraquedas', 'Pedido')}
            ],
            attachmentFiles : [],
            newSolicitation: {},
            ordersLinkDialog: false,
            orderLinksToApply: [],
            justification : {
                priority : '',
                classification : ''
            },
            deadlineOnly : false,
            billDialog: false,
            controlProductivityCallId: null,
            controlProductivityDialog: false,
            lastCallIdAccessed: null,
            accessType: {
                in: 'E',
                out: 'S'
            },
            callTypes: {
                customer: 'customer',
                operator: 'operator'
            },
            sendBudgetDialog: false,
            budgetPath: null,
            budgetAttachmentId: null,
            loadingBudget: false,
            loadingSendPrint: false,
            updateProductionBase: false,
            updateTestBase: false,
            inactivityDialog: false,

            //#region Geração de pdf
            pdfDialog: false,
            formRules: [
                v => !!v || (translate('Campo obrigatório', 'Pedido'))
            ],
            loadingAttachmentPdf: false,
            loadingGenerateAttachmentPdf: false,
            loadingSendAttachmentPdf: false,
            //#endregion
        }
    },
    watch: {
        async fastSearchProducts(val) {
            if( val && val.length >= 2) await this.getFilterValues(val)
        },
        async fastSearchClients(val) {
            if( val && val.length >= 2) await this.getFilterValues(val)
        },
        async fastSearchResponsibles(val) {
            if( val && val.length >= 2) await this.getFilterValues(val)
        },
        async fastSearchRequesters(val) {
            if( val && val.length >= 2) await this.getFilterValues(val)
        },
    },
    methods: {
        onResize() {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
            this.buildborderTabs()
            this.buildborderTabs2()
        },
        buildborderTabs() {
            setTimeout(function(){
                var allTabs = document.getElementsByClassName('pedidoTab')
                var widthBorderBoddom = 0
                allTabs.forEach(function(tab){
                    widthBorderBoddom += tab.offsetWidth
                })
                var element = document.getElementById('borderBottomTabs')
                element.style.width = `${widthBorderBoddom}px`
            },500)
        },
        buildborderTabs2() {
            setTimeout(function(){
                var allTabs = document.getElementsByClassName('pedidoTab2')
                var widthBorderBoddom = 0
                allTabs.forEach(function(tab){
                    widthBorderBoddom += tab.offsetWidth
                })
                var element = document.getElementById('borderBottomTabs2')
                element.style.width = `${widthBorderBoddom}px`
            },500)
        },
        undoClassification(){
            this.order.autoClassified = 'manual'
            this.order.SERVICO_CLASSIFICACAO_ID = {}
            this.order.answers = []
        }
        ,
        openSelectClassification(){
            this.classificationModal = true
        },
        closeClassificationDialog(){
            this.defaultClassification()
            this.classificationModal = false
        },
        saveClassification(event){
            this.classificationModal = false
            this.order.autoClassified = 'auto'
            let classification = this.orderClassifications.filter(c => c.ID == event.id)
            this.order.SERVICO_CLASSIFICACAO_ID = classification[0] || {}
            this.order.answers = event.answers
        },
        getClients(){
            this.loading = true
            getClientsByCompanyIdAndName({}).then(response => {
                this.clients = response.data
            }) 
        },
        async getProducts(){
            this.loading = true
            await getProductsByCompanyIdAndName().then(response => {
                this.products = response.data
            })
        },
        async isReadyToEmail(){
            if(this.defaultOrder.CLASSIFICACAO_DESCRICAO == 'ABONADO' && !this.justification.classification){
                this.dialogJustifyClassification = true
                return
            }
            if(this.defaultOrder.PRIORIDADE == 'URGENTE' && !this.justification.priority){
               this.dialogJustifyPriority = true
                return
            }else if(!this.justification.deadline && !this.defaultOrder.patch){
                this.deadlineOnly = true
                this.dialogJustifyPriority = true
                return
            }
            await this.emailPlanning()
            return true
        }
        ,
        async justifyPriorityHandler(input){
            this.dialogJustifyPriority = false
            this.justification.priority = input.motive
            this.justification.deadline = input.deadline
            this.defaultOrder.patch = input.patch
            this.deadlineOnly = false
            const emailSent = await this.isReadyToEmail()
            if(emailSent) await updateCallSituation({ callId: this.order.ID, situationColumn: 'EM_DESENVOLVIMENTO' })
            if(this.justification.deadline) await this.deadline()
        },
        justifyClassificationHandler(input){
            this.dialogJustifyClassification = false
            this.justification.classification = input
            this.isReadyToEmail()
        }
        ,
        async emailPlanning(){
            this.loading = true
            await sendMailPlanning({pedido:this.defaultOrder, user:this.user, justification : this.justification})
            this.loading = false
        },
        async deadline(){
            await updateDeadline({deadlineDate: this.justification.deadline, serviceId: this.order.SERVICO_ID})
        }
        ,
        async getOrder(){
            this.loading = true
            await getAllOrders({orderId:this.orderId})
                .then(function(response){
                    this.order = response.data.order
                    this.order.USUARIO = this.user.NOME
                    this.defaultOrder = JSON.parse(JSON.stringify(this.order))
                    this.messages = [].concat(response.data.messages)
                    if(this.order.manuallySelected) this.manualSelection = true
                    this.updateViewMessages()
                }.bind(this))
                .finally(this.loading = false)
        },
        async loadAllOrders(){
            this.loading = true
            await getAllOrders({allOrders:true, companyId:this.user.EMPRESA_ID})
                .then(function(response){
                    this.orders = response.data
                }.bind(this))
                .finally(this.loading = false)
        },
        async updateViewMessages(){
            this.loading = true
            await updateViewsByCallId(this.user.USUARIO_ID, this.order.ID)
                .finally(this.loading = false)
        },
        async addMessage(){
            this.loading = true
            let message = {
                USUARIO_ID: this.user.USUARIO_ID,
                TEXTO: this.newComment,
                ATENDIMENTO_ID: this.order.ID,
                notifyUsers: [].concat(this.order.orderResponsibles, this.order.orderRequesters),
                attachments: this.order.attachments
            }
            message.notifyUsers = message.notifyUsers.filter(function(notifyUser){
                return notifyUser.USUARIO_ID != message.USUARIO_ID
            })
            await addNewMessage(message)
                .then(function(){
                    this.newComment = ''
                    this.order = {}
                    this.getOrder()
                }.bind(this))
                .finally(this.loading = false)
        },
        async loadAllMessages() {
            this.loading = true
            await loadAllMessagesByCallId(this.order.ID)
                .then(function(response){
                    this.messages = response.data
                }.bind(this))
                .finally(this.loading = false)
        }, 
        editItem(item){
            this.$nextTick(function(){
                item.edit = true
            })
        },
        createFile(array, file) {
            this.attachmentFiles.push(file)
            array.push({ARQUIVO: file.name, NOME: file.name})
            this.newFileAttachment = ''
        },
        expandMenu(event){
            event.stopPropagation()
            this.expand = !this.expand
            event.target.parentElement.classList.toggle('active')
            event.target.classList.toggle('active')
            let topMenuCard = document.getElementById('topMenuCard')
            topMenuCard.classList.toggle('active')
        },
        gotoCall(callType){
            if(this.order.ID){
                const ct = callType ? callType : this.callTypes.customer
                this.$router.push({
                    path: '/atendimento',
                    query: {
                        id: this.order.ID,
                        callType: ct
                    }
                }).then(() => {
                    window.location.reload();
                });
            } 
        },
        gotoOrder(orderId){
            this.$router.push('/pedido/'+orderId).then(() => window.location.reload())
        },
        changeSearchProperty(filter) {
            this.searchProperty = filter
        },
        async getFilterValues(stringSearch) {
            this.loadingFilterValues = true
            var self = this
            let filter = {
                companyId: self.user.EMPRESA_ID,
                clientId: self.order.client ? self.order.client.ID : null,
                name: stringSearch
            }
            await this.requestsmethods[this.searchProperty](filter)
                .then(function(response){
                    this[this.searchProperty] = response.data
                    this.loadingFilterValues = false
                }.bind(this))
                .finally(this.loadingFilterValues = false)
        },
        async getAllResponsibles(){
            this.loading = true
            let data = {
                companyId : this.user.EMPRESA_ID
            }
            await loadAllResponsible(data).then(response => {
                this.responsibles = response.data
            })
        }
        ,
        addClient(){
            this.clients.push({NOME: this.fastSearchClients, new: true})
        },
        addResponsible(){
            this.editedItem.EMPRESA_ID = this.user.EMPRESA_ID
            if(this.editedItem.type == 'C') this.editedItem.client = this.order.client
            this.order.orderResponsibles.push(Object.assign(this.editedItem, {IMAGEM_PERFIL: null, new: true}))
            this.closeDialog()
        },
        addRequester(){
            this.editedItem.EMPRESA_ID = this.user.EMPRESA_ID
            if(this.editedItem.type == 'C') this.editedItem.client  = this.order.client
            this.order.callRequesters.push(Object.assign(this.editedItem, {IMAGEM_PERFIL: null, new: true}))
            this.closeDialog()
        },
        addUser(subject){
            this.typeNewUser = subject
            this.dialogSuccess = subject == 'requester' ? this.addRequester : this.addResponsible
            this.addUserDialog = true
            this.setCallResponsibles()
        },
        goBack(){
            this.$router.push('/pedidos')
        },
        openWindowAttachment(){
            var inputFile = document.getElementById('fileDialogId')
            inputFile.click()
        },
        openWindowSolicitationAttachment(item){
            this.solicitation = item
            var inputFile = document.getElementById('fileSolicitation')
            inputFile.click()
        },
        async addAuthorization(){
            this.order.authorizations.push({DESCRICAO : this.newAuthorization.DESCRICAO, attachment: this.newAuthorization.attachment.name || ''})
            if(this.newAuthorization.attachment){
                this.attachmentFiles.push(this.newAuthorization.attachment)
            }
            this.newAuthorization.DESCRICAO = ''
            this.newAuthorization.attachment = {}
        },
        requestClassificationOrder(){
            this.classificationIAModal = true
        },
        saveIAClassification(event){
            this.classificationIAModal = false
            this.order.autoClassified = 'auto'
            let classification = this.orderClassifications.filter(c => c.ID == event.id)
            this.order.SERVICO_CLASSIFICACAO_ID = classification[0] || {}
            this.order.answers = []
            if(event.hours != null) this.order.QTD_HORAS = event.hours
        },
        cancelNewAuthorization(item){
             this.order.authorizations = this.order.authorizations.filter(function(authorization) {
                return authorization != item
            })
            this.attachmentFiles = this.attachmentFiles.filter(function(file){
                return file.name != item.attachment
            })
        },
        addFile(){
            this.createFile(this.order.attachments, this.newFileAttachment)
        },
        addSolicitationFile(event){
            if(!event.target.files || !event.target.files.length) return
            var file = event.target.files[0]
            var reader = new FileReader()
            reader.onload = (event) => {
                this.solicitation.attachment = {NOME:file.name, DIRETORIO:'./public/anexoSolicitacao', file:event.target.result}
            }
            reader.readAsDataURL(file)
        },
        removeAttachment(event, item){
            event.stopPropagation()
            this.order.attachments = this.order.attachments.filter(function(attachment) {
                return attachment != item
            })
            this.attachmentFiles = this.attachmentFiles.filter(function(att){
                return att.name != item.ARQUIVO
            })
        },
        async removeSolicitationAttachment(event, item){
            event.stopPropagation()
            await deleteSolicitationAttachment(item).then(this.getAuthorizations())
        },
        async downloadFile(data){
            var url = data.LINK_ANEXO ? `${this.baseUrl}${data.LINK_ANEXO}` : `${this.baseUrl}${data.ARQUIVO.split('./public')[1]}/${data.ID}.${data.NOME.split('.')[1]}`
            fetch(url)
                .then(response => response.blob())
                .then(blob => {
                const link = document.createElement("a")
                link.href = URL.createObjectURL(blob)
                link.download = data.LINK_ANEXO ? data.NOME_ANEXO : data.NOME
                link.click()
            })
            .catch(console.error)
        },
        async save(){
            if(!this.order.SOLICITAR_ATUALIZACAO_IMEDIATA && !this.order.ID){
                this.requestUpdateModal = true
                this.updateProductionBase = false
                this.updateTestBase = false
            }else{
                if(this.manualSelection && this.order.SERVICO_CLASSIFICACAO_ID) this.order.autoClassified = 'manual'
                this.order.ID ? await this.update() : await this.addNewOrder()
            } 
        },
        async requestUpdateAndConfirm(){
            this.requestUpdateModal = false
            this.order.SOLICITAR_ATUALIZACAO_IMEDIATA = this.updateProductionBase
            this.order.SOLICITAR_ATT_IMEDIATA_TESTE = this.updateTestBase
            await this.addNewOrder()
        },
        async confirmOrder(){
            if((this.order.SERVICO_CLASSIFICACAO_ID.ID == '1' || this.order.SERVICO_CLASSIFICACAO_ID.ID == '4') && !this.order.authorizations.length){
                this.errorDialog = true
                return
            }
            await updateOrder({type : 'confirm', old:this.defaultOrder, new:this.order}).then(() => {
                window.location.reload()
            })
        },
        async uploadAttachments(file){
            if(!file.name) return
            let formData = new FormData()
            formData.append('file', file, file.name)
            await addAttachment({order : this.order.PEDIDO}, formData)
        }
        ,
        async update(){
            if(this.deepEqual(this.defaultOrder, this.order)) return
            else {
                if(this.attachmentFiles.length){

                    for(let file of this.attachmentFiles){
                        await this.uploadAttachments(file)
                    }
                }
                this.loading = true
                this.defaultOrder.USUARIO_ID = this.user.USUARIO_ID
                this.order.USUARIO_ID = this.user.USUARIO_ID
                await updateOrder({old:this.defaultOrder, new:this.order})
                    .then(()=>{
                        this.$router.push('/pedido/' + this.orderId).then(() => window.location.reload())
                    })
            }
        },
        deepEqual(object1, object2) {
            return JSON.stringify(object1) == JSON.stringify(object2)
        },
        async addNewOrder(){
            this.requestUpdateModal = false
            this.loading = true
            this.order.EMPRESA_ID = this.user.EMPRESA_ID
            this.order.USUARIO_ID = this.user.USUARIO_ID
            await insertOrder(this.order)
                .then(async function(response){
                    this.order.PEDIDO = response.data.orderId
                    if(this.attachmentFiles.length){

                        for(let file of this.attachmentFiles){
                            await this.uploadAttachments(file)
                        }
                    }
                    this.$router.push('/pedido/' + response.data.orderId).then(() => window.location.reload())
                }.bind(this))
                .finally(this.loading = false)
        },
        showMessageViewIcon(item){
            var show = false
            for(var i = 0; i < item.views.length; i++) 
                if(item.views[i].VISUALIZADO == 'S' && item.views[i].USUARIO_ID != item.USUARIO_ID && item.views[i].USUARIO_ID != this.user.USUARIO_ID) show = true
            return show
        },
        validateForm() {
            if(!this.editedItem.NOME || !this.editedItem.NOME.length)  return false
            if(!this.editedItem.EMAIL || !this.editedItem.EMAIL.length)  return false
            return true
        },
        closeDialog(){
            this.editedItem = {type:'P'}
            this.addUserDialog = false
            this.setCallResponsibles()
        },
        removeItemFromArray(array, item) {
            array = array.filter(function(i) {
                return i != item
            })
        },
        async getAllCallsToLink() {
            this.loading = true
            await getAllCallsByCompanyIdAndUserId({companyId:this.user.EMPRESA_ID, userId:this.user.USUARIO_ID})
                .then(function(response){
                    this.callsToLink = response.data
                }.bind(this))
                .finally(this.loading = false)
        },
        cancelChangeLinks(){
            this.callsLinkDialog = false
        },
        applyChangeLinks(){
            this.order.relatedCalls = [].concat(this.linksToApply)
            this.callsLinkDialog = false
        },
        cancelChangeOrderLinks(){
            this.ordersLinkDialog = false
        },
        applyChangeOrderLinks(){
            this.order.relatedOrders = [].concat(this.orderLinksToApply)
            this.ordersLinkDialog = false
        },
        async print() {
            this.loadingBudget = true
            this.budgetPath = null
            this.budgetAttachmentId = null
            await uploadEmailReport({pedido : this.order, user : this.user}).then((response) => {
                this.budgetPath = `${this.baseUrl}/${response.data.filename}`
                this.budgetAttachmentId = response.data.attachmentId
                this.sendBudgetDialog = true
            }).finally(() => this.loadingBudget = false)
        },
        async sendPrint(){
            this.loadingSendPrint = true
            await sendEmailReport({pedido : Object.assign(this.order, { attachmentId: this.budgetAttachmentId }), user : this.user})
            this.sendBudgetDialog = false
            this.loadingSendPrint = false
        },
        setCallResponsibles(){
            this.orderResponsibles = this.order.orderResponsibles.filter(function(item){
                return item.USUARIO_ID || item.new
            })
        },
        // clearRequesters() {
        //     while(this.order.callRequesters.length) this.order.callRequesters.pop()
        //     while(this.clients.length) this.clients.pop()
        // },
        async getOrderAreas() {
            await getOrderAreasList().then(function(response){
                this.orderAreas = response.data
            }.bind(this))
        },
        getMenusInformations() {
            getOrderTypes().then(function(response){
                this.orderTypes = response.data
                this.getOrderAreas()
            }.bind(this))
            getOrderClassifications().then(function(response){
                this.orderClassifications = response.data 
            }.bind(this))
            getOrderSituations().then(function(response){
                this.situations = response.data
                for(let i = 0; i < response.data.length; i++){
                    this.orderSituations.push(response.data[i].NOME)
                }
            }.bind(this))
            getAllpaymentConditions().then(function(response){
                this.orderPaymentConditions = response.data 
            }.bind(this))
        },
        setResponsibleOrder(item){
            this.order.RESPONSAVEL_USUARIO_ID = item.USUARIO_ID
            var aux = []
            for(let i = 0; i < this.order.orderResponsibles.length; i++) {
                if(this.order.orderResponsibles[i].USUARIO_ID != item.USUARIO_ID){
                    this.order.orderResponsibles[i].active = false
                }
                aux.push(this.order.orderResponsibles[i])
            }
            while(this.order.orderResponsibles.length) this.order.orderResponsibles.pop()
            for(let i = 0; i < aux.length; i++) this.order.orderResponsibles.push(aux[i])
        },
        async getDefaultPaymentCondition(){
            let data = this.order.CLIENTE
            await getDefaultPaymentCondition(data).then(response => {
                if(response.data) this.order.CONDICAO_PGTO_ID = response.data
            })
        }
        ,
        setRequesterOrder(item){
            this.order.SOLICITANTE_USUARIO_ID = item.USUARIO_ID
            var aux = []
            for(let i = 0; i < this.order.orderRequesters.length; i++) {
                if(this.order.orderRequesters[i].USUARIO_ID != item.USUARIO_ID){
                    this.order.orderRequesters[i].active = false
                }
                aux.push(this.order.orderRequesters[i])
            }
            while(this.order.orderRequesters.length) this.order.orderRequesters.pop()
            for(let i = 0; i < aux.length; i++) this.order.orderRequesters.push(aux[i])
        },
        async program(){
            if(!this.order.ID){
                this.$notify.warning({
                    title: translate('Atenção' , 'Pedido'),
                    message: translate('Para programar uma entrega, primeiro salve o pedido!', 'Pedido')
                });
                return
            }

        },
        async insertSolicitation() {
            if(!this.order.ID){
                this.$notify.warning({
                    title: translate('Atenção' , 'Pedido'),
                    message: translate('Para solicitar alguma autorização, primeiro salve o pedido!', 'Pedido')
                });
                return
            }
            this.newSolicitation.SOLICITANTE_USUARIO_ID = this.user.USUARIO_ID
            this.newSolicitation.PEDIDO_ID = this.order.ID
            await insertAuth(this.newSolicitation).then(function(){
                this.newSolicitation = {}
            }.bind(this))
        },
        async getOccurences(){
            this.loadingOccurences = true
                let params = {
                    service : this.order.SERVICO_ID
                }
            await loadAllOccurences(params)
                .then(function(response){
                    this.occurences = response.data
                }.bind(this))
                .finally(this.loadingOccurences = false)
        }
        ,
        async getAuthorizations() {
            this.loadingAuthorization = true
            let params = {
                service : this.order.SERVICO_ID
            }
            await loadAllAuthorizationsByOrderId(params)
                .then(function(response){
                    this.order.authorizations = response.data
                }.bind(this))
                .finally(this.loadingAuthorization = false)
        },
        async updateAuthorization(data, changeDateAuthorization) {
            if(changeDateAuthorization) data.DATA_HORA_AUTORIZACAO = moment()
            this.loadingAuthorization = true
            await updateAuth(data)
                .then(this.getAuthorizations())
                .finally(this.loadingAuthorization = false)
        },
        // newOrder functions
        async getNewOrderClient(){
            let data = {
                cnpj : this.$route.params.newOrder.clientCNPJ
            }

            await getNewOrderClient(data.cnpj).then( response => {
            if(response.data) this.order.CLIENTE = response.data})
            
        },
        async updateRequestItems(){
            this.loading = true
            await getRequestItems({productId : this.order.PRODUTO.ID}).then(response => {
                this.order.SERVICO_SOLICITADO = response.data
                this.loading = false
            })
        }
        ,
        async getNewOrderProduct(){
            await getRequestItems({productId : this.order.PRODUTO.ID}).then(response => {
                this.order.SERVICO_SOLICITADO = response.data
            })
        },
        async getNewOrderResponsible(){
             let data = {
                email : this.$route.params.newOrder.emailResponsavel
            }

            await getResponsibleByEmail(data.email).then( response => {
                this.order.RESPONSAVEL = response.data.NOME
            })
        },
        openBillDialog(){
            if(this.readOnly) return
            this.billDialog = true
        },
        closeBillDialog(){
            this.billDialog = false
        },
        onSuccessBillDialog(){
            this.order.FATURAR = 'N'
            this.closeBillDialog()
        },
        defaultClassification(){
            this.order.SERVICO_CLASSIFICACAO_ID = this.orderClassifications.filter(oc => {
                return oc.DESCRICAO ? oc.DESCRICAO.includes('IMPLANTAÇÃO') : false
            })[0] || {}
        },
        closeControlProductivityModal(){
            this.controlProductivityDialog = false
        },
        stopPreviousAndStartWorkingInThisCall(){
            this.closeControlProductivityModal()
            this.insertUserAccess(this.accessType.out, this.lastCallIdAccessed).then(() => {
                this.insertUserAccess(this.accessType.in, this.controlProductivityCallId)
            })
        },
         stopWorkingInThisCall(){
            this.insertUserAccess(this.accessType.out, this.controlProductivityCallId)
        },
        startWorkingInThisCall(){
            this.insertUserAccess(this.accessType.in, this.controlProductivityCallId)
        },
        closeInactiveModal(){
            this.inactivityDialog = false
        },
        setUserActionListener(){
            let self = this
            const inactivityTime = this.stillWorkingTime
            let inactivityTimer;

            function resetTimer() {
                clearTimeout(inactivityTimer);
                inactivityTimer = setTimeout(showMessage, inactivityTime);
            }

            function showMessage() {
                getLastUserAccesInCall({userId: self.user.USUARIO_ID}).then((response) => {
                    const lastUserAccess = response.data
                    if(lastUserAccess.TIPO_ACESSO === self.accessType.in){
                        self.stopWorkingInThisCall()
                        self.inactivityDialog = true
                    }
                })
            }

            // eventos que "contam" como atividade
            ["click", "mousemove", "keydown", "scroll", "touchstart"].forEach(event => {
                if(!self.inactivityDialog) window.addEventListener(event, resetTimer);
            });

            // inicia na primeira vez
            resetTimer();
        },
        insertUserAccess(accessType, callId){
            const params = {
                userId: this.user.USUARIO_ID,
                callId: callId,
                accessType: accessType,
                userType: this.getUserType()
            }
            return insertUserAccessInCall(params)
        },
        controlProductivity(){
            getLastUserAccesInCall({userId: this.user.USUARIO_ID}).then((response) => {
                const lastUserAccess = response.data
                this.lastCallIdAccessed = lastUserAccess.ATENDIMENTO_ID

                const isSameCall = this.lastCallIdAccessed == this.controlProductivityCallId
                const hasNoAccessYet = !Object.keys(lastUserAccess).length
                const isStartWorking = hasNoAccessYet || lastUserAccess.TIPO_ACESSO === this.accessType.out
                const isOpenDialog = lastUserAccess.TIPO_ACESSO === this.accessType.in && !isSameCall

                if(isStartWorking){
                    this.insertUserAccess(this.accessType.in, this.controlProductivityCallId)
                } else if(isOpenDialog){
                    this.controlProductivityDialog = true
                }
            })
        },
        createTabEvent(){
            document.addEventListener("visibilitychange", this.tabEventFunction)
        },
        destroyTabEvent(){
            document.removeEventListener("visibilitychange", this.tabEventFunction)
        },
        tabEventFunction(){
            if (document.visibilityState === "visible" && !this.inactivityDialog) {
                this.controlProductivity()
            }
        },
        getUserType(){
            return this.user.CLIENTE_ID ? 'customer' : 'operator'
        },
        async openFile(){
            await getFile(this.budgetPath).then(response => {
                const tagHref = URL.createObjectURL(response.data)
                const link = document.createElement("a")
                link.href = tagHref
                link.target = '_blank'
                document.body.append(link)
                link.click()
                link.remove()  
            })
        },
        async generateAttachmentPdf(){
            const isValid = this.$refs.generatePdfForm.validate()
            if(!isValid) return

            this.loadingGenerateAttachmentPdf = true
            try {
                const response = await generateAttachmentPdf({ order: this.order.PEDIDO, id: this.order.SERVICO_ANEXO_PDF_ID })
                this.order.CAMINHO_ANEXO = response.data.item
            } catch (error) {
                console.log(error)
            } finally {
                this.loadingGenerateAttachmentPdf = false
            }
        },
        async saveAttachmentPdf(){
            const isValid = this.$refs.generatePdfForm.validate()
            if(!isValid) return 

            this.loadingAttachmentPdf = true
            try {
                const requestField = this.getNewComment('pdfGeneratorEditorRequest')
                const detailField = this.getNewComment('pdfGeneratorEditorDetail')
                const params = {
                    ACESSO: this.order.ACESSO,
                    LOGIN: this.order.LOGIN,
                    SENHA: this.order.SENHA,
                    ROTINA: this.order.ROTINA,
                    BASE: this.order.BASE,
                    OBJETIVO: this.order.OBJETIVO,
                    DETALHAMENTO: detailField,
                    SOLICITACAO: requestField,
                    SERVICO_ID: this.order.SERVICO_ID,
                    USUARIO_ID: this.user.USUARIO_ID,
                    ID: this.order.SERVICO_ANEXO_PDF_ID
                }
    
                if(this.order.SERVICO_ANEXO_PDF_ID) await updateAttachmentPdf(params)
                else {
                    insertAttachmentPdf(params).then(response => {
                        this.order.SERVICO_ANEXO_PDF_ID = response.data.id
                    })
                } 
            } catch (error) {
                console.log(error)
            } finally {
                this.loadingAttachmentPdf = false
            }
        },
        getNewComment(editorId){
            const editor = document.getElementById(editorId)
            const images = editor.querySelectorAll('img')
            images.forEach((img) => {
                img.width = img.clientWidth
                img.height = img.clientHeight
            })
            return editor.firstElementChild.innerHTML
        },
        openAttachmentPdf(){
            window.open(this.order.CAMINHO_ANEXO, '_blank')
        },
        removeDialogPersistentAnimation(){
            const pdfDialog = this.$refs.pdfDialog
            if (pdfDialog && pdfDialog.animateClick) {
                pdfDialog.animateClick = () => {} // mata o bounce
            }
        },
        async sendAttachmentPdfEmail(){
            this.loadingSendAttachmentPdf = true
            try {
                const params = {
                    customerEmail: this.order.CLIENTE.EMAIL,
                    order: this.order.PEDIDO,
                    attachmentPdfId: this.order.SERVICO_ANEXO_PDF_ID,
                    USUARIO_ID: this.user.USUARIO_ID,
                    ATENDIMENTO_ID: this.order.ID
                }
                await sendAttachmentPdf(params)
            } catch (error) {
                console.log(error)
            } finally {
                this.loadingSendAttachmentPdf = false
            }
        }
    },
    computed:{
        ...user.mapGetters(['user', 'stillWorkingTime']),
        getClientCall(){
            return !!this.order.CONTATO_NOME
            && !!this.order.RESPONSAVEL
            && !!this.order.SITUACAO
            && !!this.order.COD_TIPO
            && !!this.order.COD_TIPO.CODIGO
            && !!this.order.ASSUNTO
            && !!this.order.SERVICO_SOLICITADO
            && !!this.order.SERVICO_CLASSIFICACAO_ID.ID
            && !!this.order.QTD_HORAS
            && !!this.order.RECURSO_ID
            && !!this.order.RECURSO_ID.ID
            && !!this.order.PRODUTO  
            && !!this.order.CLIENTE
            && !!this.order.CLIENTE.ID
        },
        readOnly(){
            return this.order.SITUACAO != 'Aguardando Confirmação' && !!this.order.PEDIDO
        },
        confirmed(){
            return this.order.SITUACAO == 'Confirmado'
        },
        attachmentPdfName(){
            return this.order.CAMINHO_ANEXO ? `anexo_${this.order.PEDIDO}.pdf` : ''
        },
        isSpecification(){
            return this.order.SERVICO_CLASSIFICACAO_ID.DESCRICAO.includes('ESPECIFICAÇÃO')
        },
        disableAttachmentPdfEmail(){
            return !this.isSpecification || !this.order.CAMINHO_ANEXO
        }

    },
    async created(){
        this.orderId = this.$route.params.id
        this.onResize()
        await this.getClients()
    },
    beforeDestroy(){
        if(this.controlProductivityCallId){
            disconnectSocket()
        } 
        this.destroyTabEvent()
    },
    async mounted() {
        this.onResize()
        this.removeDialogPersistentAnimation()

        if(this.$route.params.newOrder){
            this.newOrderMode = true
            this.orderId = false
            this.order.atendimentoId = this.$route.params.newOrder.callNumber
        }
        if(this.orderId){
            await this.getOrder()
        } else {
            this.order.orderResponsibles = [{USUARIO_ID:this.user.USUARIO_ID, NOME:this.user.NOME, IMAGEM_PERFIL:this.user.IMAGEM_PERFIL}]
            // this.order.DATA_INICIO = moment(new Date()).format('DD/MM/YYYY'),
            // this.order.DATA_LIMITE = moment(new Date()).format('DD/MM/YYYY')
        }
        //#region Controle de produtividade
        this.controlProductivityCallId = this.order.ID || this.order.atendimentoId
        if(this.controlProductivityCallId){
            this.controlProductivity()
            this.createTabEvent()
            connectSocket(this.user.USUARIO_ID, this.controlProductivityCallId, this.getUserType())
        }
        //#endregion
        if(this.newOrderMode){
            this.order.relatedCalls.push({ID:this.$route.params.newOrder.callNumber})
            this.order.CONTATO_NOME = this.$route.params.newOrder.solicitante
            this.order.SITUACAO = this.$route.params.newOrder.situation ? this.$route.params.newOrder.situation : 'Aguardando Confirmação'
            this.order.COD_TIPO = this.$route.params.newOrder.orderType,
            this.order.RECURSO_ID = this.$route.params.newOrder.resourceId
            this.order.SERVICO_CLASSIFICACAO_ID = this.$route.params.newOrder.orderClassification
            this.order.CONDICAO_PGTO_ID = this.$route.params.newOrder.paymentConditionId
            this.order.QTD_HORAS = this.$route.params.newOrder.appointedHours
            this.order.SERVICO_SOLICITADO = this.$route.params.newOrder.requestItems,
            this.order.ASSUNTO = this.$route.params.newOrder.subject
            this.order.PRODUTO = this.$route.params.newOrder.produtoId
            this.order.FATURAR = this.$route.params.newOrder.toInvoice
            this.order.answers = []
            this.getNewOrderClient().then(() => {
                if(!this.order.CONDICAO_PGTO_ID.ID) this.getDefaultPaymentCondition()
            })
            if(!this.order.SERVICO_SOLICITADO) this.getNewOrderProduct()
            this.getNewOrderResponsible()
        }
        await this.getProducts()
        if(this.orderId) {
             this.getAuthorizations()
        }
        await this.getOccurences()
        await this.getMenusInformations()
        // this.setCallResponsibles()
        await this.getAllResponsibles()
        var self = this
        self.linksToApply = [].concat(self.order.relatedCalls)
        await this.getAllCallsToLink()
        await this.loadAllOrders()
        this.setUserActionListener()
        if(!this.order.SITUACAO) this.order.SITUACAO = 'Aguardando Confirmação'
        this.order.USUARIO_LOGADO = this.user.PRIMEIRO_NOME
    }
}
</script>
<style scoped>
.bodyPage{
    max-width: none !important;
    width: 100%;
    overflow-x: auto;
    padding: 1% 0px 2% 70px;
    text-align: left;
    position: fixed;
    height: 100%;
}
.editor >>> .ql-container > .ql-editor * {
    font-size: 18px;
}

.default-size-text-field >>> input, .default-size-text-field >>> textarea {
    font-size: 18px;
}

.btnClassificarIA{
    display: flex;
    justify-content: center;
    align-items: center;
}

.btn1{
    text-transform: none !important;
}
.text-left{
    text-align: left;
}
.titlePage{
    font-size: 20px;
    font-weight: 700;
}
.leftMenu{
    height: 100%;
    width: 100%;
    padding: 10px;
}
.leftMenuCardBody{
    overflow-x: auto;
    max-height: 78%;
    min-height: 78%;
}
.leftMenuCardBody::-webkit-scrollbar {
    width: 8px;
}

.leftMenuCardBody::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}

.leftMenuCardBody::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}
.bolder{
    font-weight: bolder !important;
}
.bolder >>> *{
    font-weight: bolder !important;
}
.orderPage{
    height: 100%;
    width: 100%;
    padding-right: 0;
    padding-left: 0;
}
.tabBody{
    padding: 12px;
    height: 98%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
}
.tabBody::-webkit-scrollbar {
    width: 8px;
}
.tabBody::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}
.tabBody::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}
.tabBody2{
    padding: 12px;
    height: 95%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
}
.tabBody2::-webkit-scrollbar {
    width: 8px;
}
.tabBody2::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}
.tabBody2::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}
.panelRigthBody{
    display: contents;
    width: 96%;
    height: 100%;
    position: relative;
    left: 2em;
    font-size: 20px;
    font-weight: bolder;
}
.noPaddingCol{
    padding: 0px 12px;
}
.row{
    margin:0;
}
.fontSize >>> *{
    font-size: 12px !important;
}
.chipChat{
    margin-left: 1em;
}
.spanComment{
    content: "\A";
    white-space: break-spaces;
}
.spanComment > *{
    margin-bottom: 0 !important;
}
.cardCommentText{
    overflow-y: auto;
}
.cardCommentText::-webkit-scrollbar {
    height: 8px;
}

.cardCommentText::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}

.cardCommentText::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}
.topMenu{
    position: absolute;
    width: 100%;
    height: 100%;
    background: #ececec;
    top: 0;
    z-index: 5;
    left: 0;
    display: flex;
    justify-content: center;
    border-radius: 0px 0px 50px 50px;
    max-height: 30px;
    transition: max-height 0.25s ease-out;
}
.topMenu.active{
    max-height: 94%;
    transition: max-height 0.25s ease-in; 
    border-radius: 0px 0px 20px 20px;
}
.topMenuCard{
    width: 100%;
    height: 100%;
    background: #ececec;
    top: 0;
    z-index: 5;
    max-height: 0px;
    transition: max-height 0.25s ease-out;
    visibility: hidden;
    box-shadow: none !important;
}
.topMenuCard.active{
    max-height: 92%;
    transition: max-height 0.25s ease-in; 
    visibility: visible;
}
.downIcon{
    position: absolute;
    transform: rotate(0deg);
    transition: transform 0.25s linear;
    bottom: -4px;
    z-index: 1001;
}
.downIcon.active{
    transform: rotate(180deg);
    transition: transform 0.25s linear;
}
.topDrawer{
    position: absolute;
    width: 100%;
    background: #ececec;
    top: 0;
    z-index: 4;
    left: 0;
}
.topMenu{
    visibility: hidden;
}
.textRight{
    text-align: end;
}
.datePickerCol{
    padding-bottom: 0;
}
.kndChip{
    padding: 0px 0px 0px 8px; 
    margin: 0;
    height: 30px; 
    margin: 0px 1px 3px 1px !important;
}
.kndChip.active{
    background-color: #b3b3b3;
}
.cardActions{
    height: 60px;
    min-height: 60px;
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: center;
    width: 100%;
}
.attachments{
    width: 88%;
    max-width: 88%;
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
    height: 3em;
    align-items: center;
}
.attachments::-webkit-scrollbar {
    height: 8px;
}

.attachments::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}

.attachments::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}
.attachments > div:hover{
    cursor: pointer !important;
}
.cardChat{
    background: #ececec;
}
.cardChat::before{
    border-right-color: #ececec !important;
}
.cardChat::after{
    border-right-color: #ececec !important;
}
.bodyCallLink{
    max-height: 400px;
    overflow-y: scroll;
    overflow-x: hidden;
}
.bodyCallLink::-webkit-scrollbar {
    width: 8px;
}

.bodyCallLink::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}

.bodyCallLink::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}
.assuntoColumn{
    max-width: 140px;
}
.inlineTable{
    display: inline-table !important;
}
.headerCallInfo{
    display: inline-table !important;
    margin-bottom: 0 !important;
}
.headerCallInfo>.actions{
    display: flex;
    flex-wrap:wrap;
    margin-top:10px;
}
.headerCallInfo>.actions>button{
    margin-top:8px;
}
.borderBottomTabs{
    border-bottom: 4px solid #80808052;
    position: relative;
    top: 50px;
    width: 1px;
    z-index: 1;
    border-radius: 50px;
}
.pedidoTab, .pedidoTab2{
    text-transform: none !important;
}
.attachmentListItem:hover{
    cursor: pointer;
    background-color: rgb(231, 231, 231);
}
.maxWidth{
    max-width: 200px;
}
.call-menu {
    box-shadow: none;
    display: unset;
}
.call-menu >>> .v-card{
    font-size: 12px;
}
.call-menu >>> .v-list {
    background-color: transparent; 
    padding: 0;
    border: none;
}
.call-menu >>> .v-list-item {
    padding: 0;
    min-height: auto;
}
.call-menu > div, .call-menu >>> .v-list-item > .v-card {
    padding: 4px 8px 4px 8px; 
    background: #e0e0e0; 
    margin-right:1px; 
    border-radius:22px; 
    cursor:pointer; 
    font-weight: bolder; 
    border: thin solid rgba(0, 0, 0, .12); 
    min-height: auto;
}
@media only screen and (max-width: 420px){
    .leftMenu{
        display: none;
    }
    .bodyPage{
        padding: 6% 0px 11% 0px;
    }
    .topMenu{
        visibility: visible;
    }
    .headerCallInfo{
        display: inline-table !important;
    }
    .cardActions{
        display: inline-table !important;
    }
    .cardActions > button {
        width: inherit;
        margin-top: 4px;
    }
    .leftMenuCardBody{
        max-height: 56%;
        min-height: 56%;
    }
}
@media only screen and (min-width: 421px) and (max-width: 814px){
    .leftMenu{
        display: none;
    }
    .bodyPage{
        padding: 0;
    }
    .bodyPage{
        padding: 0% 0px 6% 40px;
    }
    .topMenu{
        visibility: visible;
        padding-left: 70px;
    }
    .topMenuCard{
        max-height: 60% !important;
    }
    .headerCallInfo{
        display: inline-table !important;
    }
    .cardActions{
        display: inline-table !important;
    }
    .cardActions > button {
        width: inherit;
        margin-top: 4px;
    }
    .leftMenuCardBody{
        max-height: 100%;
        min-height: 100%;
    }
}
@media only screen and (min-width: 815px) and (max-width: 2000px){
    .headerCallInfo{
        display: inline-table !important;
    }
    .cardActions{
        display: inline-table !important;
    }
    .cardActions > button {
        width: inherit;
        margin-top: 4px;
    }
    .leftMenuCardBody{
        max-height: 70%;
        min-height: 70%;
    }
}
</style>